export const INSPECT_TYPE = {
  GENSHA: 0,
  LEGAL56: 1,
  RECOMMEND: 2,
  INSPECT_LINE: 3,
  RECOMMEND_MANUAL: 4,
  USER_MANUAL: 5,
  JIZEN: 6,
};
